import $ from "jquery";
import { useNavigate } from "react-router-dom";
import Eralogo22 from "../../assets/images/Eralogo22.png";
import Navigator from "../extra/Navigator";
import { warning } from "../../util/Alert";
import { useDispatch } from "react-redux";
import { LOGOUT_ADMIN } from "../store/admin/admin.type";
import { projectName } from "../../util/config";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    const data = warning();
    data
      .then((logout) => {
        if (logout) {
          dispatch({ type: LOGOUT_ADMIN });
          navigate("/");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCloseSideBar = () => {
    if (window.innerWidth <= 992) {
      $(".sideBar").toggleClass("mobSidebar webSidebar");
    }
  };

  const navBarArray = [
    {
      name: "Dashboard",
      path: "/admin/dashboard",
      iconName: "LayoutDashboard",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Product Management" },

    {
      name: "Attribute",
      path: "/admin/attribute",
      iconName: "Key",
      onClick: handleCloseSideBar,
    },
    {
      name: "Category",
      path: "/admin/category",
      path2: "/admin/category/subCategory",
      iconName: "Grid",
      onClick: handleCloseSideBar,
    },
    {
      name: "PromoCode",
      path: "/admin/promocode",
      iconName: "Percent",
      onClick: handleCloseSideBar,
    },
    {
      name: "Product Request",
      iconName: "ShoppingCart",
      subMenu: [
        {
          subName: "Pending Requests",
          subPath: "/admin/pendingProduct",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Approved Requests",
          subPath: "/admin/approvedProduct",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Reject Requests",
          subPath: "/admin/rejectedProduct",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Product",
      iconName: "ShoppingBasket",
      subMenu: [
        {
          subName: "Real",
          subPath: "/admin/product",
          subPath2: "/admin/productDetail",
          subPath3: "/admin/addProduct",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Fake",
          subPath: "/admin/fakeproduct",
          subPath2: "/admin/fake/productDetail",
          subPath3: "/admin/fake/addProduct",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Reels",
      iconName: "Film",
      subMenu: [
        {
          subName: "Real",
          subPath: "/admin/reels",
          subPath2: "/admin/real/reels/details",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Fake",
          subPath: "/admin/fakereels",
          subPath2: "/admin/fake/reels/details",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Reels Report",
      path: "/admin/videoreport",
      iconName: "FileText",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Order & Seller" },

    {
      name: "Seller",
      iconName: "Store",
      subMenu: [
        {
          subName: "Pending Request",
          subPath: "/admin/sellerRequest",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Real Seller",
          subPath: "/admin/seller",
          subPath2: "/admin/sellerProfile",
          subPath3: "/admin/addSeller",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Fake Seller",
          subPath: "/admin/fakeSeller",
          subPath3: "/admin/addFakeSeller",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Live Seller",
      path: "/admin/liveseller",
      path2: "/admin/liveSellerProduct",
      iconName: "Radio",
      onClick: handleCloseSideBar,
    },
    {
      name: "Order",
      path: "/admin/order",
      path2: "/admin/order/orderDetail",
      iconName: "PackageCheck",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "User Management" },

    {
      name: "User",
      path: "/admin/user",
      path2: "/admin/UserProfile",
      iconName: "Users",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Finance" },

    {
      name: "Seller Withdrawal",
      path: "/admin/adminwithdrawal",
      iconName: "Wallet",
      onClick: handleCloseSideBar,
    },
    {
      name: "Admin Earning",
      path: "/admin/wallet",
      iconName: "CreditCard",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Help & Settings" },

    {
      name: "FAQ",
      path: "/admin/faq",
      iconName: "HelpCircle",
      onClick: handleCloseSideBar,
    },
    {
      name: "Setting",
      iconName: "Settings",
      subMenu: [
        {
          subName: "App Setting",
          subPath: "/admin/setting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Payment Setting",
          subPath: "/admin/paymentSetting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Withdraw Setting",
          subPath: "/admin/withDraw",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Bank Setting",
          subPath: "/admin/bankSetting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Currency Setting",
          subPath: "/admin/currencySetting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Report Reason Setting",
          subPath: "/admin/reportreason",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Profile",
      path: "/admin/profilePage",
      iconName: "User",
      onClick: handleCloseSideBar,
    },
  ];

  return (
    <>
      <div 
        className="mainSidebar" 
        style={{
          borderRight: "1px solid #e5e5e5",
          height: "100vh",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div className="sideBar webSidebar" style={{ 
          display: "flex", 
          flexDirection: "column", 
          height: "100%",
          overflow: "hidden"
        }}>
          {/* Logo Section */}
          <div
            className="sideBarLogo"
            onClick={() => navigate("/admin/dashboard")}
            style={{
              padding: "24px 20px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              borderBottom: "1px solid #f0f0f0",
              flexShrink: 0
            }}
          >
            <img 
              src={Eralogo22} 
              alt="" 
              width="50px" 
              style={{ marginRight: "12px" }} 
            />
            <span 
              style={{ 
                color: "#000", 
                fontSize: "20px", 
                fontWeight: "700",
                letterSpacing: "-0.5px"
              }}
            >
              {projectName}
            </span>
          </div>

          {/* Navigation Section - Scrollable */}
          <div 
            className="navigation" 
            style={{ 
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden",
              padding: "16px 0"
            }}
          >
            <nav>
              {navBarArray.map((item, idx) => {
                if (item.sectionTitle) {
                  return (
                    <p
                      key={`section-${idx}`}
                      style={{ 
                        padding: "16px 20px 8px 20px",
                        margin: "0",
                        color: "#9ca3af",
                        fontWeight: "600",
                        fontSize: "11px",
                        textTransform: "uppercase",
                        letterSpacing: "1px"
                      }}
                    >
                      {item.sectionTitle}
                    </p>
                  );
                }

                return (
                  <Navigator
                    key={`nav-${idx}`}
                    name={item.name}
                    path={item.path}
                    path2={item.path2}
                    subPath3={item.path3}
                    iconName={item.iconName}
                    onClick={item.onClick}
                  >
                    {item.subMenu &&
                      item.subMenu.map((sub, subIdx) => (
                        <Navigator
                          key={`sub-${idx}-${subIdx}`}
                          subName={sub.subName}
                          subPath={sub.subPath}
                          subPath2={sub.subPath2}
                          subPath3={sub.subPath3}
                          onClick2={sub.onClick2}
                        />
                      ))}
                  </Navigator>
                );
              })}
            </nav>
          </div>

          {/* Logout Section - Fixed at Bottom */}
          <div 
            style={{
              borderTop: "1px solid #f0f0f0",
              padding: "16px 0",
              flexShrink: 0
            }}
          >
            <Navigator
              name="Logout"
              iconName="LogOut"
              onClick={handleLogout}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;